import { render, staticRenderFns } from "./StageSelect.vue?vue&type=template&id=2445660e&scoped=true&"
import script from "./StageSelect.vue?vue&type=script&lang=js&"
export * from "./StageSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2445660e",
  null
  
)

export default component.exports